import { worksOrdersApi } from "./works-ordersApi";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { WorkOrderFull, WorkOrderSimple, CreateWorkOrder, ParamsWorkOrder } from "./works-orders.interface";
import { RootState } from "@/app/store";
import { APIError, APIResponse } from "@/types/custom-http";

export const fetchWorkOrdesSimple = createAsyncThunk<
  APIResponse<WorkOrderSimple[]>,
  ParamsWorkOrder,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'workorders/fetchWorkOrdersSimple',
  async (params: ParamsWorkOrder, { dispatch, rejectWithValue }) => {
    try {
      const result = await dispatch(
        worksOrdersApi.endpoints.getWorksOrders.initiate(params)
      ).unwrap();
      return result;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
        return rejectWithValue({
          status,
          message: data?.message || 'Error al obtener listado simple de ordenes de trabajo',
          details: data.details
        });
    }
  }
);


export const fetchWorkOrdersFull = createAsyncThunk<
  APIResponse<WorkOrderFull[]>,
  void,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'workorders/fetchWorkOrdersFull',
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const result = await dispatch(
        worksOrdersApi.endpoints.getWorksOrdersFull.initiate()
      ).unwrap();
      return result;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
        return rejectWithValue({
          status,
          message: data?.message || 'Error al obtener listado completo de ordenes de trabajo',
          details: data.details
        });
    }
  }
);


export const fetchWorkOrderById = createAsyncThunk<APIResponse<WorkOrderFull>, number,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'workorders/fetchWorkOrderById',
  async (id: number, { dispatch, rejectWithValue }) => {
    try {
      const result = await dispatch(
        worksOrdersApi.endpoints.getWorkOrderById.initiate(id)
      ).unwrap();
      return result;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
      return rejectWithValue({
        status,
        message: data?.message || 'Error al obtener Orden de Trabjo por ID',
        details: data.details
      });
    }
  }
);


export const createWorkOrder = createAsyncThunk<APIResponse<WorkOrderSimple>, CreateWorkOrder,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'workorders/createWorkOrder',
  async (data: CreateWorkOrder, { dispatch, rejectWithValue }) => {
    try {
      // Disparamos la mutación y esperamos el resultado
      const result = await dispatch(
        worksOrdersApi.endpoints.createWorkOrder.initiate(data)
      ).unwrap();
      
      return result;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
      return rejectWithValue({
        status,
        message: data?.message || 'Error al crear Orden de Trabajo',
        details: data.details
      });
    }
  }
);